import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ADMIN_BASE } from '../utils/adminBase';

export default function AdminLogin() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.username, form.password);
      navigate(ADMIN_BASE || '/');
    } catch (err) {
      // Distinguish a wrong password from a lockout or an unreachable
      // server — all three used to show the same "invalid" message.
      const status = err.response?.status;
      if (status === 401) setError('Invalid email or password.');
      else if (status === 429) setError(err.response.data?.error || 'Too many failed attempts. Please try again in 15 minutes.');
      else if (!err.response) setError('Cannot reach the server. Please check that the website backend is running.');
      else setError(`Login failed (server error ${status}). Please try again later.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-dark to-primary flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-block bg-white/10 px-6 py-3 mb-3">
            <span className="font-display font-bold text-2xl tracking-widest text-accent">SANKYO</span>
          </div>
          <p className="text-white/60 text-sm">Admin Portal</p>
        </div>

        <div className="bg-white shadow-2xl p-8">
          <h2 className="font-display text-xl font-bold text-primary mb-6">Sign In</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Email</label>
              {/* type="text", not "email" — the backend accepts any login
                  identifier, and HTML5 email validation would silently block
                  submitting a non-email-shaped one (e.g. before a rename). */}
              <input type="text" value={form.username} onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
                required autoFocus placeholder="name@sankyomt.ph"
                className="w-full border border-gray-200 px-4 py-2.5 text-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Password</label>
              <input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                required
                className="w-full border border-gray-200 px-4 py-2.5 text-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
            </div>

            {error && <p className="text-red-500 text-sm bg-red-50 px-3 py-2 border border-red-100">{error}</p>}

            <button type="submit" disabled={loading}
              className="w-full btn-primary py-3 text-sm tracking-widest uppercase disabled:opacity-60 mt-2">
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
